import type React from 'react'

import {LABELS, TEST_IDS} from '../constants'
import {CommentHeaderBadge} from './CommentHeaderBadge'

type Props = {
  viewerDidAuthor?: boolean
}

export const CommentSubjectAuthor: React.FC<Props> = ({viewerDidAuthor}: Props) => {
  return (
    <CommentHeaderBadge
      viewerDidAuthor={viewerDidAuthor}
      ariaLabel={LABELS.commentSubjectAuthoer(viewerDidAuthor ?? false)}
      label={LABELS.commentAuthor}
      testId={TEST_IDS.commentSubjectAuthor}
    />
  )
}

try{ CommentSubjectAuthor.displayName ||= 'CommentSubjectAuthor' } catch {}